import { useRegisterSW } from 'virtual:pwa-register/react';

/**
 * Offers a reload when a new version has been downloaded.
 *
 * Deliberately a prompt rather than an automatic reload: reloading under someone mid-shop
 * would lose whatever they were typing into the add box. The service worker registers
 * with `autoUpdate`, so the new version is already sitting there — this only decides
 * when it takes over.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) {
    return null;
  }

  return (
    <div className="update-prompt" role="status">
      <span>A new version is ready.</span>
      <div className="update-prompt__actions">
        <button
          type="button"
          className="button button--primary button--small"
          onClick={() => void updateServiceWorker(true)}
        >
          Reload
        </button>
        <button
          type="button"
          className="button button--quiet button--small"
          onClick={() => setNeedRefresh(false)}
        >
          Later
        </button>
      </div>
    </div>
  );
}
